import Booking from "./booking";
import FlightRoute from "./flightRoute";
import vueMainInstance from "../../main";

export default class FlightBooking extends Booking {
  constructor() {
    super();
    this.passenger_name = "";
    this.start_date = "";
    this.end_date = "";
    this.return_start_date = "";
    this.return_end_date = "";
    this.start_time = "";
    this.end_time = "";
    this.return_start_time = "";
    this.return_end_time = "";
    this.start_airport_code = "";
    this.end_airport_code = "";
    this.return_start_airport_code = null;
    this.return_end_airport_code = null;
    this.airline_name = "";
    this.start_airport_name = "";
    this.end_airport_name = "";
    this.return_start_airport_name = "";
    this.return_end_airport_name = "";
    this.itinerary = "";
    this.routes = [];
  }

  load(userId, loadUrl = "booking/get-flight-booking-detail?bookingId=") {
    vueMainInstance.axios.get(loadUrl + userId).then(resp => {
      this.id = resp.data.id;
      this.type = resp.data.type;
      this.name = resp.data.name;
      this.ticket_number = resp.data.ticket_number;
      this.reservation_number = resp.data.reservation_number;
      this.client_name = resp.data.client_name;
      this.client_surname = resp.data.client_surname;
      this.total_amount = resp.data.total_amount;
      this.creation_date = resp.data.creation_date;
      this.is_cancelled = resp.data.is_cancelled;
      this.used_in_delegation = resp.data.already_used;
      this.invoice_id = resp.data.invoice_id;
      this.invoice_number = resp.data.invoice_number;
      //flight extension
      this.passengers = resp.data.passengers;
      this.start_date = resp.data.start_date;
      this.end_date = resp.data.end_date;
      this.return_start_date = resp.data.return_start_date;
      this.return_end_date = resp.data.return_end_date;
      this.start_time = resp.data.start_time;
      this.end_time = resp.data.end_time;
      this.return_start_time = resp.data.return_start_time;
      this.return_end_time = resp.data.return_end_time;
      this.start_airport_code = resp.data.start_airport_code;
      this.end_airport_code = resp.data.end_airport_code;
      this.return_start_airport_code = resp.data.return_start_airport_code;
      this.return_end_airport_code = resp.data.return_end_airport_code;
      this.airline_name = resp.data.airline_name;
      this.start_airport_name = resp.data.start_airport_name;
      this.end_airport_name = resp.data.end_airport_name;
      this.return_start_airport_name = resp.data.return_start_airport_name;
      this.return_end_airport_name = resp.data.return_end_airport_name;
      this.itinerary = resp.data.itinerary;

      this.routes = [];

      this.invoices = resp.data.invoices;

      if (resp.data.routes != null) {
        for (let routeData of resp.data.routes) {
          let route = new FlightRoute();
          route.loadFromApiData(routeData);
          this.routes[route.sequence_index] = route;
        }
      }
    });
  }
}
